jQuery(function($) {
	const base = "gc-cart-item";
	$(`.${base}__remove-button`).on('click',function() {
		const id = $(this).attr("data-product-id");
		$(this).prop('disabled', true);

		fetch(`/wp-json/growl/cart/removeItem/${id}`)
		.then(function (response) {	return response.json() })
		.then((result) => {  
			location.reload();
		});
	});

	$(`.${base} .gc-quantity__input`).on('change',function() {
		const id = $(this).closest('.gc-cart-item__bottom').attr("data-product-id");
		const value = $(this).val();
		$(this).prop('disabled', true);

		fetch(`/wp-json/growl/cart/updateQuantity/${id}/${value}`)
		.then(function (response) {	return response.json() })
		.then((result) => {  
			location.reload();
		});
	});
});